// Fix HG (2026-10-20): "este filtro debería estar ordenado de A - Z, pero más que nada también permitir escribir
// el nombre de obra" (CEN). Opciones para el desplegable con buscador de obras (SelectBuscable): ordenadas de la A
// a la Z sin distinguir mayúsculas ni acentos; si dos obras se llaman igual se les agrega el código para distinguirlas.
export function opcionesObras(projects) {
  const lista = (projects || []).filter((p) => p && p._id);
  const nombreDe = (p) => String(p.name || "").trim();
  const veces = {};
  lista.forEach((p) => { const k = nombreDe(p).toLowerCase(); veces[k] = (veces[k] || 0) + 1; });
  return lista
    .map((p) => {
      const nombre = nombreDe(p) || "(sin nombre)";
      return { value: p._id, label: veces[nombreDe(p).toLowerCase()] > 1 && p.code ? `${nombre} · ${p.code}` : nombre };
    })
    .sort((a, b) => a.label.localeCompare(b.label, "es", { sensitivity: "base", numeric: true }));
}

// Fix HR (2026-10-23): "presenta números que no hacen referencia al presupuesto. Hagamos que sea mucho más específico:
// que en el filtro se muestre NOMBRE DE OBRA - ÚLTIMOS 3 DÍGITOS DEL CÓDIGO DE PRESUPUESTO - MONTO TOTAL C/ IVA. Siempre
// ordenado de A - Z orden alfabético para facilitar cualquier vista rápida" (CEN, Claudio). Opciones de obra para
// Facturación y Cobranza: dos obras con el mismo nombre se distinguen por su presupuesto y su monto. Si aun así
// dos quedan iguales (proyectos repetidos de un mismo presupuesto) se les agrega el código. Además del texto de la
// etiqueta, el buscador encuentra por cliente, N° de presupuesto completo y código de proyecto.
export function opcionesObrasPpto(projects) {
  const lista = (projects || []).filter((p) => p && p._id);
  const ppto3 = (p) => String(p.presupuesto_numero || "").replace(/\D/g, "").slice(-3) || "s/PPTO";
  const monto = (p) => Math.round(Number(p.presupuesto_total ?? p.budget_pyg) || 0);
  const filas = lista.map((p) => {
    const nombre = String(p.name || "").replace(/\s+/g, " ").trim() || "(sin nombre)";
    return { p, nombre, ppto: ppto3(p), monto: monto(p), label: `${nombre} - ${ppto3(p)} - Gs. ${monto(p).toLocaleString("es-PY")}` };
  });
  const veces = {};
  filas.forEach((f) => { veces[f.label.toLowerCase()] = (veces[f.label.toLowerCase()] || 0) + 1; });
  return filas
    .sort((a, b) => a.nombre.localeCompare(b.nombre, "es", { sensitivity: "base", numeric: true })
      || a.ppto.localeCompare(b.ppto, "es", { numeric: true }) || a.monto - b.monto
      || String(a.p.code || "").localeCompare(String(b.p.code || ""), "es", { numeric: true }))
    .map((f) => ({
      value: f.p._id,
      label: veces[f.label.toLowerCase()] > 1 && f.p.code ? `${f.label} · ${f.p.code}` : f.label,
      buscar: `${f.p.client || ""} ${f.p.presupuesto_numero || ""} ${f.p.code || ""}`,
    }));
}
